//* Vue Router
import type { RouteRecordRaw } from "vue-router";

export const useRoutes = () => {
    const modules = import.meta.glob("./src/**/*.ts", { eager: true });
    const routes: RouteRecordRaw[] = [];
    for (const key in modules) {
        const datas = (modules[key] as { default?: RouteRecordRaw[] })?.default || [];
        datas.forEach((route) => {
            routes.push(route);
        });
    }

    return routes;
};
